module.exports = {
  worker: {
    auth: {
      phone_input: {
        auth_header: 'Авторизация',
        emoji: '👋🏻',
        phone_numb_text: 'Введите ваш номер телефона. Мы вышлем на него код для входа.',
        btn_get_pass: 'Получить SMS пароль',
      },
      code_input: {
        auth_header: 'Авторизация',
        emoji: '👋🏻',
        text: 'На номер +* (***) *** ** ** отправлен пароль для входа.',
        text_input: 'Введите пароль из SMS',
        code_validatoin_error: 'Введён неверный код',
        limit_error: 'Превышен лимит попыток входа. Обратитесь в поддержку: +7 (495) 215-53-58',
        btn_in: 'Войти',
        send_code_again: 'Отправить код еще раз (** сек.)',
        another_number_input: 'Ввести другой номер телефона',
      },
    },
    sidejob_search: {
      cookies: {
        cookies_header: '🍪 Cookies',
        text_inf: 'Для корректной работы сайта мы используем cookies.',
        btn_ok: 'Хорошо',
      },
      map_list: {
        map_name: 'Карта',
        list_name: 'Список',
        text_input: 'Поиск подработки',
        toast_nothing_found: 'Всё будет, но позже',
      },
      nothing_found_list: {
        header_nothing_found: 'Ничего не найдено',
        text_param_changes: 'Попробуйте изменить параметры поиска или воспользуйтесь фильтрами.',
      },
      request_for_new_by_empty_search: {
        find_later_header: 'Найдётся позже',
        text_put_number: 'Оставьте свой номер, и мы пришлем SMS, когда появятся похожие предложения',
        send_btn: 'Отправить',
      },
      search_history_by_text: {
        search_history_header: 'История поиска',
      },
    },
    filters: {
      filters_list: {
        search_filters_header: 'Фильтры поиска',
        discard: 'Сбросить все',
        active_btn: 'Найдено Х',
        disable_btn: 'Ничего не найдено',
      },
      geo_filters: {
        search_near_header: 'Искать рядом с вами',
        text_input: 'Адрес для поиска рядом',
        current_location: 'Текущее местоположение',
      },
      profession_filters: {
        profeccion_header: 'Профессии',
        empty_state_text: 'Выберите подходящие профессии в списке',
        'option_btn (когда не выбрано)': 'Выбрать',
        'change_btn (когда выбрано)': 'Изменить',
        exp_active: 'Есть опыт',
        exp_inactive: 'Без опыта',
      },
      date: {
        date_header: 'Даты',
        choise_btn: 'Календарь',
        night_job_offer: 'Предлагать ночную подработку',
      },
      instruction: {
        instruction_header: 'Обучение',
        toggle_instruction_job: 'Предлагать подработку с обучением',
        time_header: 'Время на обучение',
      },
      docs: {
        docs_header: 'Документы',
      },
      subscription: {
        subscr_header: 'Подписка',
        description: 'Мы пришлём уведомление, как только появятся новые предложения по вашему запросу.',
        add_to_fav: 'Добавить в избранное',
        subscribe: 'Получать уведомления',
      },
      prof_choice: {
        prof_choice_header: 'Выбрать профессии',
        drop: 'Очистить',
        done_btn: 'Готово',
      },
      calendar_date_select: {
        calendar_header: 'Календарь',
        drop: 'Очистить',
        done_btn: 'Готово',
      },
    },
    sidejob_card: {
      search_sidejob_card: {
        toast_add_to_fav: 'Предложение добавлено в избранное ❤️',
        toast_deleted_from_fav: 'Предложение удалено из избранного ❤️',
        toast_addr_copied: 'Адрес скопирован в буфер обмена',
        details_header: 'Детали',
        exp_required: 'Опыт работы: обязателен',
        exp_not_required: 'Опыт работы: не обязателен',
        instruction_button: 'Инструкция и правила работы',
        payment_header: 'Оплата',
        payment_time: 'В конце смены 🔥',
        payment_text: 'На ваш счёт вы получите: ***',
        help_link_how_recieve_money: 'Как получить деньги на карту?',
        tax_text: 'Налог составит: ***',
        help_link_tax: 'Что такое налог?',
        btn_take_sidejob: 'Взять подработку',
        docs_header: 'Документы',
        empty_date: 'Сейчас нет предложений',
        similar_btn: 'Похожие предожения',
      },
      popap_offer_not_relevant: {
        offer_not_relevant_header: 'Подработка не актуальна',
        emoji: '⚠️',
        text_offer_inf: 'Это предложение уже кто-то забронировал. Добавьте его в избранное, чтобы быть в курсе новых предложений.',
        button_add_to_fav: 'В избранное ♡',
      },
      instructions: {
        job_descr_header: 'Должностная инструкция',
        emoji: '👀',
        checkout_descr: 'Ознакомьтесь пожалуйста.',
      },
    },
    reservation: {
      reservation_scrn: {
        sidejob_reserv_header: 'Бронирование подработки',
        emoji: '🔥',
        datails: 'Детали',
        terms_descr: 'Чтобы забронировать эту подработку, необходимо подтвердить опыт и добавить недостающие документы.',
        docs_header: 'Необходимые документы',
        offer_header: 'Оферта',
        offer_btn_before: 'Подписать',
        offer_btn_after: 'Подписана',
        self_employed_header: 'Статус самозанятого',
        self_empl_btn_before: 'Подтвердить',
        self_empl_btn_after: 'Подтверждён',
        instruction_header: 'Инструкция и описание работы',
        instruction_btn_before: 'Ознакомиться',
        instruction_btn_after: 'Ознакомился',
      },
      docs_loading: {
        ph_load_header: 'Загрузите фото документов',
        ph_emoji: '📷',
        load_descr: 'Это займёт не более 10 минут. Документы нужны для того, чтобы ваша работа была легальной. ',
        helplink_docs: 'Не получается загрузить документы',
        load_btn: 'Загрузить',
        done_btn: 'Готово',
        helplink_medocal: 'У меня нет медицинской книжки',
      },
      self_employed_status: {
        self_employed_header: 'Статус самзанятого',
        headline: 'Получить статус',
        description: 'Это займёт не более 10 минут.',
        emoji: '🤓',
        helplink: 'Что такое статус самозанятого?',
        step_1: 'Скачайте приложение «Мой Налог»',
        step_2: 'Следуйте инструкции в приложении чтобы пройти регистрацию',
        helplink_step_2: 'Подробная инструкция',
        step_3: 'Возвращайтесь на эту страницу, чтобы завершить регистрацию',
        inn_form_descr: 'Скопируйте ИНН и вставьте в форму для проверки:',
        inn_form_input_text: 'Вставьте ваш ИНН',
        inn_form_helplink: 'Как узнать свой ИНН?',
        inn_form_btn: 'Проверить статус',
        help_descr: 'Не разобрались? Специалист контакт-центра поможет:',
        help_btn: 'Позвонить оператору',
      },
      offer: {
        offer_header: 'Оферта',
        emoji: '👀',
        offer_descr: 'Прочтите и примите оферту',
        acept_btn: 'Принять',
      },
      instruction: {
        job_descr_header: 'Должностная инструкция',
        emoji: '👀',
        check_descr: 'Ознакомьтесь пожалуйста.',
        ready_btn: 'Я ознакомился',
      },
      sucsess_reserv_scrn: {
        emoji: '😉',
        reserv_header: 'Подработка забронирована!',
        add_descr: 'И добавлена в ваше Расписание',
      },
    },
    fav: {
      fav_header: 'Избранное',
      sentence: {
        sentence_header: 'Предожения',
        toast_del_confirm: 'Вернуть',
      },
      empty_setntence: {
        emoji: '🤷🏼‍♂️',
        fav_empty_header: 'Нет избранных предложений',
        fav_text: 'Нажмите «♡» в карточке подработки и она появится здесь.',
      },
      empty_filters: {
        emoji: '🤷🏻‍♀️',
        non_fav_filters_header: 'Нет избранных фильтров',
        text: 'Передвиньте тумблер «Добавить в ♡ Избранное» в фильтрах поиска и он появится здесь.',
        fav_card_header_fewprofs: 'Несколько профессий',
        when: 'Когда: ',
        train: 'Обучение: ',
        new_offers: 'Х новых предложений',
        notifications: 'Уведомления',
      },
    },
    shedule: {
      shedule: {
        shedule_header: 'Расписание',
      },
      empty_shedule: {
        empty_shedule_header: 'В вашем расписании пусто',
        emoji: 'нет',
        reserv_jobs_text: 'Здесь появятся забронированные вами подработки',
        find_sidejob_btn: 'Найти подработку',
      },
    },
    sidejob_shedule_card: {
      booked: {
        time_header: 'До начала смены осталось',
        booked_header: 'Подработка забронирована',
        need_docs_text: 'Обязательно возьмите с собой документы: Х',
      },
      'booked за 16 часов': {
        timer_header: 'До начала смены осталось',
        confrm_header: 'Подтвердите бронирование',
        confrm_text: 'Подтвердите, что вы придёте на подработку. Если у вас поменялись планы, пожалуйста, сообщите об этом, чтобы мы могли найти вам замену.',
        confrm_yellow_btn: 'Да, я приду',
        decline_white_btn: 'Нет, отмените',
      },
      'booked/going за 30 минут': {
        timer_header: 'До начала смены осталось',
        check_header: 'Вы на месте?',
        check_text: 'Отметьте начало работы, как только придёте на место.',
        inplace_yellow_btn: 'Я на месте',
        late_white_btn: 'Опаздываю',
      },
      going: {
        timer_header: 'До начала смены осталось',
        confrm_header: 'Бронирование подтверждено',
        need_docs_text: 'Обязательно возьмите с собой документы: Х',
      },
      inprogress: {
        timer_header: 'Осталось работать',
        work_going_header: 'Работа идёт!',
        end_check_text: 'Отметьте завершение работы, как только закончите.',
        done_yellow_btn: 'Я закнчил',
      },
      completed: {
        wrk_done_header: 'Работа сделана',
        check_text: 'Мы всё проверим и пришлём SMS, когда можно будет получить деньги на карту. Обычно это занимает до 30 минут.',
        comm_yellow_btn: 'Оставить отзыв',
        chng_comm: 'Изменить отзыв',
      },
      confirmed: {
        wrk_done_header: 'Работа сделана',
        earn_text: 'Вы заработали Х ₽ за Y часов Z минут.',
        get_money_yellow_btn: 'Получить деньги',
        put_comm_white_btn: 'Оставить отзыв',
      },
      'revoked без оплаты': {
        sidejob_declined_header: 'Подработка отменена',
        declined_text: 'К сожалению, работодатель отменил эту подработку.',
      },
      'revoked с оплатой': {
        sidejob_declined_header: 'Подработка отменена',
        declined_text: 'К сожалению, работодатель отменил эту подработку. Вам начислена оплата за Х часов Y.',
        get_money_yellow_btn: 'Получить деньги',
      },
      delayed: {
        '20_late_header': 'Вы опаздываете на 20 минут',
        waiting_text: 'Мы отправили работодателю сообщение с просьбой подождать вас. Мы пришлём SMS, как только работодатель ответит.',
        inplace_yellow_btn: 'Я на месте',
      },
      toolate: {
        you_late_header: 'Вы опоздали',
        sidejob_declined_text: 'К сожалению, работодатель не готов ждать вас. Подработку пришлось отменить.',
      },
      waiting: {
        '20_late_header': 'Вы опаздываете на 20 минут',
        empl_wait_text: 'Работодатель подождёт вас. ',
        inplace_yellow_btn: 'Я на месте',
      },
      failed: {
        not_come_header: 'Похоже, вы не пришли на смену',
        sidejob_declined_text: 'К сожалению, подработку пришлось отменить. Если это ошибка, позвоните оператору контактного центра.',
        operator_call_white_btn: 'Позвонить оператору.',
      },
      cancelled: {
        sidejob_declined_header: 'Подработка отменена',
        you_decline_text: 'Вы отменили эту подработку.',
      },
      checkingin: {
        check_fail_header: 'Не удалось отметить вас',
        try_check_text: 'Если вы действительно на месте, подойдите к менеджеру и попросите отметить вас.',
        try_again_white_btn: 'Попробовать ещё раз',
      },
      checkingout: {
        check_fail_header: 'Не удалось отметить вас',
        try_check_text: 'Если вы действительно на месте, подойдите к менеджеру и попросите отметить вас.',
        try_again_white_btn: 'Попробовать ещё раз',
      },
      sidejob_cancel: {
        cancel_btn: 'Отменить',
      },
      manager: {
        inplace_manager_header: 'Менеджер на точке',
        text_btn_empty_message: 'Написать',
        text_btn_n_message: 'Х новых сообщений',
        call_btn: 'Позвонить',
      },
      similar_offers: {
        smlr_btn: 'Похожие предложения',
      },
      lateness: {
        head: 'Опоздание',
        how_time_header: 'Сколько времени нужно?',
        input_header: 'Добавить комментарий',
        late_cause_text: 'Напишите, почему вы опаздываете',
        send_btn: 'Отправить',
      },
      comment: {
        emoji: '😉',
        work_done_header: 'Работа выполнена!',
        comm_text: 'Расскажите, как прошла смена? Заказчик не увидит ваш отзыв.',
        job_comm_text: 'Отзыв о работе',
        send_btn: 'Отправить',
      },
    },
    sidejob_cancel: {
      cause_select: {
        sidejob_declined_header: 'Отмена подработки',
        emoji: '😳',
        details_header: 'Детали',
        cause_header: 'Выберите причину отмены',
        another_cause_input_text: 'Опишите, почему вы отменяете подработку?',
        cancel_sidejob_btn: 'Отменить подработку',
      },
      sidejob_cancel: {
        emoji: '👋🏻',
        sidejob_declined_header: 'Подработка отменена',
        another_sidejob_header: 'Ещё подработка',
        link_to_all: 'Все',
      },
    },
    chats: {
      chats_main: {
        messages: 'Сообщения',
        search_input_text: 'Поиск по сообщениям',
      },
      chat_page: {
        message_text: 'Текст сообщения...',
        reserved_wrk_shift: 'Забронировано Х смен',
      },
      empty_chats: {
        emoji: '✉️',
        empty_chats_header: 'Нет сообщений',
        info_text: 'Здесь можно будет переписываться с заказчиками для обсуждения деталей вашей подработки.',
      },
    },
    curtain: {
      curtain_menu: {
        on_acc: 'На счету',
        documents: 'Документы',
        notifications: 'Уведомления',
        help: 'Помощь',
        refrence: 'Как работает MyGig',
        legal_docs: 'Правовые документы',
      },
      contacts: {
        vk: 'ВКонтакте',
        tg: 'Telegram',
        phone: '+7 495 215 53 58',
      },
      'login/logout': {
        logout: 'Выйти',
        login: 'Войти',
      },
    },
    notifications: {
      notifications: {
        header: 'Уведомления',
      },
      empty_notifications: {
        emoji: '📣',
        header: 'Пока пусто',
        all_state_text: 'Все статусы подработок в одном месте, напоминания о предстоящей работе и уведомления о выплатах',
      },
    },
    profile: {
      profile_section: {
        head: 'Профиль',
        you_earn: 'Вы заработали',
        documents: 'Документы',
      },
      'Блок статус самозанятого не подтверждён': {
        text: 'Статус самозанятого подтверждён!',
      },
      'Блок статус самозанятого подтверждён': {
        attention_header: 'Внимание!',
        text: 'Для вывода средств на карту нужно подтвердить статус самозанятого гражданина.',
        confirm_btn: 'Подтвердить',
        helplink: 'Что это такое?',
      },
    },
    score: {
      operation_history_screen: {
        earn_header: 'Вы заработали',
        get_money_btn: 'Вывести деньги ',
      },
      operation_history: {
        operation_history_header: 'История операций',
        comission_text: 'Комиссия за перевод меньше 5000 ₽',
        transf_to_card_text: 'Перевод на счёт Х',
        add_sum_for_shift: 'Оплата подработки Х в Y',
      },
      get_money_screen: {
        head: 'Вывести деньги',
        howmuch_header: 'Сколько переводим?',
        sum_to_get: 'Вы получите Х ₽',
        comment: 'При переводе менее 5 000 ₽ комиссия составит 25 ₽',
        send_trasf_btn: 'Отправить перевод',
      },
      score_block: {
        header: 'Куда переводим',
        add_score_btn: 'Добавить карту',
      },
      empty_score_block: {
        add_card_text: 'Добавьте счёт вашей банковской карты',
        emoji: ' 💳',
      },
      transf_send_screen: {
        emoji: '👏🏻',
        transf_send_header: 'Перевод отправлен',
        date_of_reciept_text: 'Срок поступления денег на карту зависит от вашего банка и может составитьдо 24 часов.',
        find_new_sidejob_btn: 'Найти новую подработку',
      },
    },
    add_card: {
      input_card_inf: {
        head: 'Добавить карту',
        emoji: '💳',
        new_card_header: 'Новая карта',
        add_card_requisite_text: 'Добавьте реквизиты счёта вашей банковской карты.',
        helplink: 'Как узнать реквизиты?',
        score_requisite_header: 'Реквизиты счёта',
        score_requsite_input: 'Вставьте реквизиты счёта сюда',
        save_btn: 'Сохранить',
        card_validation_error: 'Проверьте реквизиты. Обязательно нужно ввести БИК банка, номер корреспондентского счёта и номер рассчётного счёта.',
        toast_card_added: 'Карта добалвена!',
      },
      empty_card_block: {
        no_card_header: 'Нет карты?',
        make_new_text: 'Оформите новую карту на выгодных условиях',
        make_new_now_btn: 'Оформить прямо сейчас',
      },
      sign_act_screen: {
        head: 'Акт оказания услуг',
        sign_act_header: 'Подпишите акт',
        emoji: '📄',
        read_act_text: 'Ознакомьтесь с актом оказания услуг и подпишите его.',
        act_header: 'Акт оказания услуг',
        helplink: 'Ошибка в акте?',
        download_btn: 'Скачать акт в PDF',
        sign_act_btn: 'Подписать акт',
      },
    },
    acc_blocking: {
      notification_banner: {
        '7_days_text': '😢 Аккаунт заблокирован до Х',
        all_time_text: '😢 Аккаунт заблокирован',
      },
      '7_days_blocking_details': {
        emoji: '😔',
        acc_blocking_header: 'Аккаунт заблокирован до Х ',
        acc_blocking_text: 'Ваш аккаунт заблокирован на 7 дней. Вы не можете бронировать подработку и выводить средства.',
        helplink: 'Заблокирован по ошибке?',
      },
      all_time_blocking_details: {
        emoji: '😔',
        acc_blocked_header: 'Аккаунт заблокирован',
        acc_blocking_text: 'Ваш аккаунт заблокирован. Вы не можете бронировать подработку и выводить средства.',
        helplink: 'Ошибка?',
        blocking_reason_header: 'Причины блокировки',
      },
      comment_send_screen: {
        head: 'Блокировка аккаунта',
        error: 'Ошибка?',
        emoji: '👁',
        describe_text: 'Опишите ситуацию и команда MyGig в кратчайшие сроки решит данный вопрос.',
        input_text: 'Текст сообщения',
        send_btn: 'Отправить',
        toast_sended: 'Обращение отправлено 🙂 Мы постараемся разобраться быстро.',
      },
      warning_details: {
        emoji: '😬',
        warning_header: 'Предупреждение',
        warning_text: 'Вы нарушили правила пользования сервисом в случае повторных нарушений ваш аккаунт может быть заблокирован. Будьте внимательны.',
        helplink: 'Ошибка?',
      },
    },
  },
  employer: {
    orders: {
      orders_header: 'Заказы',
      new_order_btn: 'Новый заказ',
      text_in_location_select: 'Все точки',
      tab_actual: 'Актуальные',
      tab_done: 'Завершённые',
      empty_actual: {
        emoji: '🤷🏼‍♂️',
        no_actual_offers_head: 'Нет актуальных заказов',
        make_offer_text: 'Создайте заказ, чтобы найти исполнителей',
      },
      empty_done: {
        emoji: '🤷🏼‍♂️',
        no_done_offers_head: 'Нет завершённых заказов',
        make_offer_text: 'Создайте заказ, чтобы найти исполнителей',
      },
      offer_details: {
        head: 'Детали заказа',
        all_found: 'найдено',
        not_all_found: 'идёт поиск...',
        menu_edit: 'Редактировать заказ',
        menu_cancel: 'Отменить заказ',
        menu_repeat: 'Повторить заказ',
      },
      offer_edit: {
        head: 'Редактировать заказ',
        save_btn: 'Сохранить',
      },
      toast_sucsess_edit: {
        changes_saved_text: 'Изменения сохранены👌🏻',
      },
      popup_edit_for_repeating: {
        emoji: '🤓',
        make_changes_head: 'Внести изменения',
        for_all: 'Для всех повторов заказа',
        only_this: 'Только для этого заказа',
        apply_btn: 'Применить',
      },
      cancel_offer_without_payment: {
        head: 'Заказ',
        emoji: '😳',
        offer_cancel_head: 'Отмена заказа',
        dont_cancel_blue_btn: 'Не отменять',
        cofrm_cancel_yellow_btn: 'Подтвердить отмену',
      },
      cancel_offer_witht_payment: {
        head: 'Заказ',
        offer_cancel_head: 'Отмена заказа',
        attention_text: 'Внимание! Если вы отмените заказ, с вас будет удержана компенсация в размере Х ₽ за каждого исполнителя.',
        dont_cancel_blue_btn: 'Не отменять',
        cofrm_cancel_yellow_btn: 'Подтвердить отмену',
      },
      toast_sucses_cancel: {
        offer_cancel_text: 'Заказ отменён 👌🏻',
      },
    },
    make_offer: {
      template_choose: {
        head: 'Заказ исполнителей',
      },
      shift_settings: {
        head: 'Добавить смену',
        work_point: 'Рабочая точка',
        number: 'Кол-во исполнителей',
        date: 'Когда нужен сотрудник?',
        repeat: 'Повтор заявки',
        start: 'Начало смены',
        end: 'Конец смены',
        bet: 'Ставка в час',
        add_to_offer_btn: 'Добавить в заказ',
      },
      basket: {
        head: 'Заказ исполнителей',
        add_worker_blue_btn: 'Добавить исполнителей',
      },
      browsing_added_shift: {
        dlt_from_order_red_btn: 'Удалить из заказа',
        save_yellow_btn: 'Сохранить',
      },
      processed_order: {
        processed_order_head: 'Заказ оформлен!',
        worker_searching_subtitle: 'Идёт поиск работников...',
        message_text: 'Как только найдём, пришлём SMS. Вы можете следить за ходом выполнения в разделе «Заказы».',
        orders_btn: 'Перейти в заказы',
      },
    },
    worker: {
      worker_head: 'Исполнители',
      worker_searching_input_text: 'Поиск исполнителя',
      tab_actual: 'Актуальные смены',
      tab_done: 'Завершённые смены',
      empty_worker: {
        emoji: '🤷🏻‍♀️',
        head: 'Здесь никого нет',
        text: 'Здесь появятся исполнители, которые взяли смены по вашим заказам.',
      },
      empty_search: {
        emoji: '🤷🏻‍♀️',
        head: 'Такой исполнитель не найден',
      },
    },
    worker_card: {
      card_browsing: {
        head: 'Карточка исполнителя',
        type_btn_no_messages: 'Написать',
        type_btn_n_messages: 'Х новых сообщений',
        call_btn: 'Позвонить',
        headline_block_shift: 'Смена',
        text_without_timeline: 'Исполнитель забронировал подработку.',
        text_in_going_state: 'Исполнитель подтвердил, что придёт на смену.',
        headline_block_docs: 'Документы',
        trouble_btn: 'Есть проблема',
      },
      comment: {
        work_end_head: 'Работа выполнена!',
        reiting_text: 'Пожалуйста, оцените как исполнитель справился с задачей.',
        input_text: 'Отзыв об исполнителе',
        send_btn: 'Отправить',
      },
    },
    trouble: {
      trouble_choose: {
        head: 'Есть проблема',
        help_header: 'Чем вам помочь?',
        emoji: '🐻',
      },
      trouble_send: {
        head: 'Проблема с заказом',
        emoji: '👀',
        whats_wrong_head: 'Что не так?',
        what_hapnd_text: 'Расскажите подробнее что произошло. Мы обязательно разберёмся в ситуации и сообщим о результатах по SMS.',
        message_text_input: 'Сообщение',
        toogle_end_shift: 'Завершить смену',
        comment_end_work: 'Исполнитель будет уведомлён и отправлен домой.',
        toogle_replacement: 'Найти замену',
        comment_replacement: 'Мы найдём другого исполнителя для этого заказа как можно скорее.',
        send_btn: 'Отправить',
      },
      toas_trouble_send: {
        text_without_failure: 'Ваше обращение принято 😉',
        text_with_failure: 'Работник снят со смены 👌',
        text_with_replacement: 'Работник снят со смены. Мы уже начали поиск замены!',
      },
    },
    chats: {
      chats_main: {
        messages: 'Сообщения',
        search_input_text: 'Поиск по сообщениям',
      },
      chat_page: {
        message_text: 'Текст сообщения...',
        reserved_wrk_shift: 'Забронировано Х смен',
      },
      empty_chats: {
        emoji: '✉️',
        empty_chats_header: 'Нет сообщений',
        info_text: 'Здесь можно будет переписываться с исполнителями для обсуждения деталей.',
      },
    },
    curtain: {
      curtain_menu: {
        notifications: 'Уведомления',
        help: 'Помощь',
        refrence: 'Как работает MyGig',
        legal_docs: 'Правовые документы',
      },
      contacts: {
        vk: 'ВКонтакте',
        tg: 'Telegram',
        phone: '+7 495 215 53 58',
      },
      'login/logout': {
        logout: 'Выйти',
        login: 'Войти',
      },
    },
    notifications: {
      notifications: {
        header: 'Уведомления',
      },
      empty_notifications: {
        emoji: '📣',
        header: 'Пока пусто',
        all_events_in_one: 'Все события в одном месте, сообщения о найденных и прибывших на точку исполнителях.',
      },
    },
    expenses: {
      expenses_list: {
        header: 'Расходы',
        text_all_points: 'Все точки',
      },
      empty_expenses: {
        emoji: '🤷🏻‍♀️',
        header: 'Пока пусто',
        empty_expenses_text: 'Расходов ещё не было.',
      },
    },
  },
};
